
import {Component, Mixins, Watch} from 'vue-property-decorator';
import SimpleInputMixin from '@/mixins/SimpleInputMixin.vue';
import TakipHazirlaEvrakEkleForm from '@/components/eicrapro/TakipHazirlaEvrakEkleForm.vue';

@Component({
  components: {TakipHazirlaEvrakEkleForm},
})
export default class TakipHazirlaVekaletEkleDialog extends Mixins(SimpleInputMixin) {
  activeTab = 0;
  fileFormValue: { data?: string; name?: string; mimeType?: string; hash?: string; dosya?: File | null } = {};
  vekaletList: any[] = [];
  vekaletlerLoading = false;
  fileUploadLoading = false;
  secVeEkleLoading = false;
  selectedVekalet: any[] = [];
  previewDialog = false;
  previewItem: any = null;
  previewDocData: string | null = null;
  previewDocName = '';
  previewDocMimeType = '';
  previewDocLoading = false;
  totalItems = 0;
  tableOptions: any = {page: 1, itemsPerPage: 20};
  initialLoaded = false;

  vekaletTableHeaders = [
    {text: 'Vekalet No', value: 'vekaletNo', sortable: false},
    {text: 'Vekil', value: 'vekil', sortable: false},
    {text: 'Müvekkil', value: 'muvekkil', sortable: false},
    {text: 'Tarih', value: 'tarih', sortable: false},
    {text: 'Mahkeme', value: 'mahkeme', sortable: false},
    {text: 'Durum', value: 'durum', sortable: false},
    {text: '', value: 'actions', sortable: false, width: '60px'},
  ];

  @Watch('value', {immediate: true})
  onValueChangeSync() {
    const vekalet = this.value?.vekalet;
    if (vekalet && (vekalet.data || vekalet.name)) {
      this.fileFormValue = {...vekalet, dosya: vekalet.dosya ?? null};
    } else {
      this.fileFormValue = {};
    }
  }

  onValueChange() {
    this.onValueChangeSync();
  }

  @Watch('activeTab')
  onTabChange(tab: number) {
    if (tab === 1 && !this.initialLoaded && !this.vekaletlerLoading) {
      this.loadVekaletler();
    }
  }

  @Watch('tableOptions.page')
  onPageChange() {
    if (this.initialLoaded) {
      this.loadVekaletler();
    }
  }

  @Watch('previewDialog')
  onPreviewDialogChange(val: boolean) {
    if (!val) {
      this.previewDocData = null;
      this.previewDocName = '';
      this.previewDocMimeType = '';
    }
  }

  async loadVekaletler() {
    this.vekaletlerLoading = true;
    try {
      const res = await this.$http.get('/api/v1/vekaletler', {
        params: {
          aktif: true,
          page: this.tableOptions.page,
        },
      });
      const raw = res?.data;
      const items = raw?.data ?? (Array.isArray(raw) ? raw : []);
      this.vekaletList = Array.isArray(items) ? items : [];
      this.totalItems = raw?.meta?.total ?? this.vekaletList.length;
      this.initialLoaded = true;
    } catch {
      try {
        const res = await this.$http.get('/api/v1/vekalet-list');
        this.vekaletList = Array.isArray(res.data) ? res.data : [];
        this.totalItems = this.vekaletList.length;
        this.initialLoaded = true;
      } catch {
        this.vekaletList = [];
        this.totalItems = 0;
        this.$toast.error('Vekalet listesi yüklenemedi.');
      }
    } finally {
      this.vekaletlerLoading = false;
      this.preselectVekaletObject();
    }
  }

  preselectVekaletObject() {
    const vekaletObject = this.value?.vekaletObject;
    if (!vekaletObject?.id) return;
    const found = this.vekaletList.find((v: any) => (v.id || v.fileable_id) === vekaletObject.id);
    if (found) {
      this.selectedVekalet = [found];
    } else {
      this.vekaletList = [{...vekaletObject, id: vekaletObject.id}, ...this.vekaletList];
      this.selectedVekalet = [this.vekaletList[0]];
    }
  }

  getVekilAdSoyadList(item: any): string[] {
    if (item.vekiller && item.vekiller.length > 0) {
      return item.vekiller.map((v: any) => v.adSoyad || '').filter(Boolean);
    }
    if (item.vekil && typeof item.vekil === 'object' && 'adSoyad' in item.vekil) {
      const adSoyad = (item.vekil as { adSoyad?: string }).adSoyad;
      return adSoyad ? [adSoyad] : [];
    }
    if (item.avukatlar && item.avukatlar.length) {
      const a = item.avukatlar[0];
      const name = [a.first_name ?? a.ad, a.last_name ?? a.soyad].filter(Boolean).join(' ');
      return name ? [name] : [];
    }
    return [];
  }

  getVekilAdSoyad(item: any): string {
    const list = this.getVekilAdSoyadList(item);
    return list.length ? list.join(', ') : '-';
  }

  getMuvekkilAdSoyadList(item: any): string[] {
    if (item.muvekkiller && item.muvekkiller.length > 0) {
      const parts = item.muvekkiller.map((m: any) => {
        if (m.tip === 'kisi') return m.adSoyad || '';
        if (m.tip === 'kurum') return m.sirketAdi || '';
        const kisi = m.kisi;
        const kurum = m.kurum;
        if (kisi?.ad || kisi?.soyad) return [kisi.ad, kisi.soyad].filter(Boolean).join(' ');
        if (kurum?.unvan) return String(kurum.unvan);
        if (kurum?.sirket_adi) return String(kurum.sirket_adi);
        return this.$helper?.kisiKurumAd?.(m) ?? '';
      });
      return parts.filter(Boolean);
    }
    if (item.muvekkil && typeof item.muvekkil === 'object' && 'adSoyad' in item.muvekkil) {
      const adSoyad = (item.muvekkil as { adSoyad?: string }).adSoyad;
      return adSoyad ? [adSoyad] : [];
    }
    return [];
  }

  getMuvekkilAdSoyad(item: any): string {
    const list = this.getMuvekkilAdSoyadList(item);
    return list.length ? list.join(', ') : '-';
  }

  getTarih(item: any): string {
    const t = item.vekaletTarihi || item.tarih || item.vekalet_tarihi;
    if (t) return this.$helper?.tarihStr?.(t) ?? String(t).substr(0, 10).split('-').reverse().join('/');
    return '-';
  }

  getVekaletDosyaUrl(item: any): string | null {
    const files = item.ekliDosyalar;
    if (files && files.length) {
      const first = files[0];
      const url = first?.public_url ?? first?.url;
      if (url) return url;
    }
    if (item.file_path) return `/api/v1/file/download/${String(item.file_path).replace('uploads/', '')}`;
    return null;
  }

  async openPreview(item: any) {
    this.previewItem = item;
    this.previewDocData = null;
    this.previewDocName = '';
    this.previewDocMimeType = '';
    this.previewDialog = true;
    await this.loadPreviewDocument(item);
  }

  async loadPreviewDocument(item: any) {
    this.previewDocLoading = true;
    try {
      let fileUrl: string | null = null;
      let fileName = 'vekalet.pdf';
      let mimeType = 'application/pdf';

      const directUrl = this.getVekaletDosyaUrl(item);
      const firstFile = item.ekliDosyalar?.[0];
      const firstFileUrl = firstFile?.public_url ?? firstFile?.url;
      if (firstFileUrl) {
        fileUrl = firstFileUrl;
        fileName = firstFile?.name ?? firstFile?.ad ?? 'vekalet.pdf';
      } else if (directUrl) {
        fileUrl = directUrl;
      }

      if (!fileUrl && item.id) {
        const filesRes = await this.$http.get(`/api/v1/vekalet-files/${item.id}`);
        const rawFiles = (filesRes?.data?.data?.files ?? filesRes?.data?.files ?? []) as any[];
        const fileRecord = rawFiles[0];
        if (fileRecord) {
          fileName = fileRecord.name ?? fileRecord.ad ?? 'vekalet.pdf';
          mimeType = fileRecord.mime_type ?? fileRecord.tip ?? 'application/pdf';
          if (fileRecord.file_path) {
            const baseName = String(fileRecord.file_path).split('/').pop() || '';
            if (baseName) fileUrl = `/api/v1/file/download/${encodeURIComponent(baseName)}`;
          }
          if (!fileUrl) fileUrl = fileRecord.public_url ?? null;
        }
      }

      if (!fileUrl) {
        this.previewDocLoading = false;
        return;
      }

      const isApiUrl = fileUrl.startsWith('/api/') || fileUrl.startsWith('/');
      if (isApiUrl) {
        const fullUrl = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl.replace(/^\//, '')}`;
        const blob = await this.$helper.getBlobFromLink(fullUrl);
        mimeType = blob.type || mimeType;
        const dataUrl = await this.$helper.convertToBase64(blob);
        this.previewDocData = typeof dataUrl === 'string' ? dataUrl : '';
      } else {
        try {
          const blobRes = await this.$http.get(fileUrl, {responseType: 'blob'});
          const blob = blobRes?.data;
          if (blob && blob instanceof Blob) {
            mimeType = blob.type || mimeType;
            const dataUrl = await this.$helper.convertToBase64(blob);
            this.previewDocData = typeof dataUrl === 'string' ? dataUrl : '';
          }
        } catch {
          this.previewDocData = fileUrl;
        }
      }
      this.previewDocName = fileName;
      this.previewDocMimeType = mimeType;
    } catch (error) {
      console.error('Vekalet belge yükleme hatası:', error);
      this.$toast?.error?.('Belge yüklenirken hata oluştu.');
    } finally {
      this.previewDocLoading = false;
    }
  }

  async handleFileSuccess(payload: { data: string; name: string; mimeType: string; hash?: string }) {
    this.$emit('onSuccess', payload);
  }

  private splitAdSoyad(adSoyad: string): { adi: string; soyadi: string } {
    const parts = String(adSoyad || '').trim().split(/\s+/);
    return {adi: parts[0] || '', soyadi: parts.slice(1).join(' ') || ''};
  }

  /** API vekalet-senkron format: [{tcKimlikNo: "..."}] */
  buildVekilListForSenkron(item: any): Array<{ tcKimlikNo: string }> {
    const list: Array<{ tcKimlikNo: string }> = [];
    if (item.vekiller && item.vekiller.length > 0) {
      for (const v of item.vekiller) {
        const tckn = v.tckn ?? v.kisi?.tc_kimlik_no ?? v.turkish_identification_number ?? '';
        list.push({tcKimlikNo: String(tckn || '')});
      }
    } else if (item.vekil && typeof item.vekil === 'object') {
      const tckn = item.vekil.tckn ?? item.vekil.kisi?.tc_kimlik_no ?? '';
      list.push({tcKimlikNo: String(tckn || '')});
    } else if (item.avukatlar && item.avukatlar.length > 0) {
      for (const a of item.avukatlar) {
        const tckn = a.turkish_identification_number ?? '';
        list.push({tcKimlikNo: String(tckn || '')});
      }
    }
    return list.length ? list : [{tcKimlikNo: ''}];
  }

  /** API vekalet-senkron format: { kurumMu, temelBilgileri, adresList, ibanList }[] */
  buildTarafListForSenkron(item: any): Array<any> {
    const list: Array<any> = [];
    const emptyAdresIban = {adresList: [] as any[], ibanList: [] as any[]};

    if (item.muvekkiller && item.muvekkiller.length > 0) {
      for (const m of item.muvekkiller) {
        if (m.tip === 'kisi') {
          const {adi, soyadi} = this.splitAdSoyad(m.adSoyad || '');
          list.push({
            kurumMu: false,
            temelBilgileri: {
              adi,
              soyadi,
              tcKimlikNo: String(m.tckn ?? m.kisi?.tc_kimlik_no ?? m.kisi?.turkish_identification_number ?? ''),
            },
            ...emptyAdresIban,
          });
        } else if (m.tip === 'kurum') {
          list.push({
            kurumMu: true,
            temelBilgileri: {
              kurumAdi: m.sirketAdi ?? m.kurum?.sirket_adi ?? m.kurum?.unvan ?? '',
              vergiNo: String(m.vergiNo ?? m.kurum?.vergi_no ?? ''),
              kisiKurumID: null,
              ticaretSicilNo: null,
              mersisNo: null,
              kamuOzel: 'özel',
            },
            ...emptyAdresIban,
          });
        } else if (m.kisi) {
          const adi = m.kisi.ad ?? '';
          const soyadi = m.kisi.soyad ?? '';
          list.push({
            kurumMu: false,
            temelBilgileri: {
              adi,
              soyadi,
              tcKimlikNo: String(m.kisi.tc_kimlik_no ?? m.kisi.turkish_identification_number ?? ''),
            },
            ...emptyAdresIban,
          });
        } else if (m.kurum) {
          list.push({
            kurumMu: true,
            temelBilgileri: {
              kurumAdi: m.kurum.sirket_adi ?? m.kurum.unvan ?? '',
              vergiNo: String(m.kurum.vergi_no ?? ''),
              kisiKurumID: null,
              ticaretSicilNo: null,
              mersisNo: null,
              kamuOzel: 'özel',
            },
            ...emptyAdresIban,
          });
        }
      }
    } else if (item.muvekkil && typeof item.muvekkil === 'object') {
      const {adi, soyadi} = this.splitAdSoyad(item.muvekkil.adSoyad ?? '');
      list.push({
        kurumMu: false,
        temelBilgileri: {
          adi,
          soyadi,
          tcKimlikNo: String(item.muvekkil.tckn ?? item.muvekkil.tc_kimlik_no ?? ''),
        },
        ...emptyAdresIban,
      });
    }
    return list;
  }

  async handleSecVeEkle() {
    const item = this.selectedVekalet[0];
    if (!item || !item.id) return;

    this.secVeEkleLoading = true;
    try {
      const filesRes = await this.$http.get(`/api/v1/vekalet-files/${item.id}`);
      const rawFiles = (filesRes?.data?.data?.files ?? filesRes?.data?.files ?? []) as any[];
      const fileRecord = rawFiles[0];
      if (!fileRecord) {
        this.$toast.error('Vekalet dosyası bilgisi alınamadı.');
        return;
      }

      const firstEkliDosya = item.ekliDosyalar?.[0];
      const filePath = fileRecord.file_path ?? firstEkliDosya?.file_path ?? item.file?.[0]?.file_path ?? item.file_path;
      const vekaletObject = firstEkliDosya
        ? {
            ...firstEkliDosya,
            id: firstEkliDosya.fileable_id ?? item.id,
            // uyap_takip.vekalet_id File id'si ister; id Vekalet id'si olarak kalır (önseçim buna bakıyor).
            file_id: firstEkliDosya.id,
            file_path: firstEkliDosya.file_path ?? filePath,
          }
        : {
            id: item.id,
            file_path: filePath,
            ...fileRecord,
          };
      this.$emit('onSuccess', vekaletObject);
    } catch (error) {
      console.error('Vekalet dosya bilgisi alınamadı:', error);
      this.$toast.error('Vekalet dosya bilgisi alınamadı.');
    } finally {
      this.secVeEkleLoading = false;
    }
  }
}
